<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.99976 5C6.38047 5 7.49976 3.88071 7.49976 2.5C7.49976 1.11929 6.38047 0 4.99976 0C3.61904 0 2.49976 1.11929 2.49976 2.5C2.49976 3.88071 3.61904 5 4.99976 5ZM3.99951 6.00006C2.34266 6.00006 0.999512 7.34321 0.999512 9.00006C0.999512 9.55235 1.44723 10.0001 1.99951 10.0001H7.99951C8.5518 10.0001 8.99951 9.55235 8.99951 9.00006C8.99951 7.34321 7.65637 6.00006 5.99951 6.00006H3.99951Z"
  />
</template>
